import * as Sentry from "@sentry/browser";

export function initSentry(){
    const prot = window.location.protocol
    if (prot !== 'http:' && prot !== 'https:'){
        sentry_dsn_conf = ''
    }
    Sentry.init({
        dsn: sentry_dsn_conf,
        
        release: js_app_version,
        
        // Set tracesSampleRate to 1.0 to capture 100%
        // of transactions for performance monitoring.
        // We recommend adjusting this value in production
        tracesSampleRate: 1.0,
    });
}
